module.exports = __webpack_public_path__ + "static/media/image04_2.342c4233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image04_2.jpg
// module id = 386
// module chunks = 0